import { Container } from '@mui/system';
import React from 'react'
import Title from '../../components/title/Title';
import SecondNavbar from '../../layout/navbar/SecondNavbar'

const Blog = () => {
  return (
    <>
      <SecondNavbar />
      <section className="other">
        <Container maxWidth="xl">
          <Title title="НАШ МАГАЗИН" />
          <p>
            Магазин предлагает широкий ассортимент бытовой техники и
            электроники: смартфоны и гаджеты, компьютеры и комплектующие,
            домашняя и кухонная техника, а также электроинструменты,
            автоэлектроника и многое другое. Большой выбор по каждой категории и
            по доступным ценам.
          </p>
          <p>
            Для удобства Gipermart предлагает различные методы оплаты — онлайн,
            наличными, и покупка товаров в рассрочку. Оформление рассрочки
            происходит в короткие сроки. Вместо множества справок - онлайн
            скоринг вашей карты и предоставление рассрочки от 3 до 12 месяцев.
            Благодаря партнерству с Paymart и Gipermart вы сможете выбрать
            оптимальные для Вас условия платежей и сроков. После оформления
            заказа в личном кабинете, или с помощью кнопки «Купить в один клик»,
            ваш товар направляется по указанному адресу доставки.
          </p>
          <p>Доставка по городу Ташкенту - 24 часа</p>
          <p>Доставка по регионам – 3 дня</p>
          <p>
            На любую покупку действует гарантия магазина от 1 до 24 месяцев.
          </p>
          <p>Приятных покупок с Gipermart.</p>
          <Title title="АКЦИИ" />
          <p>
            Акции от интернет-магазина Gipermart — это товары с еще более
            привлекательными условиями для покупок. В течение срока проведения
            акций, пользователи сайта Gipermart смогут выбрать подходящие для
            себя товары со скидкой, или получить подарок за покупку.
          </p>
          <p>
            Товары в разделе Успейте купить предлагаются по предельно низким
            ценам. Обратный отсчет на карточке товара показывает сколько
            осталось до конца акции. До истечения срока покупатели могут купить
            нужный товар сразу или оформить рассрочку.
          </p>
          <p>
            Ассортимент товаров по всем категориям каждый раз обновляется.
            Исходя из спроса и трендов на рынке, посетителям сайта предлагаются
            актуальные модели бытовой техники и электроники. Благодаря рейтингу
            и отзывам на сайте также можно определить, какие товары пользуются
            наибольшей популярностью на отечественном рынке.
          </p>
          <Title title="ОНЛАЙН-КОНСУЛЬТАЦИЯ" />
          <p>
            Если у вас возникли вопросы при совершении покупок в
            интернет-магазине Gipermart, вы можете обратиться к
            онлайн-консультантам, которые помогут сделать правильный выбор
            товара, исходя из того, что нужно именно Вам. А также расскажут о
            характеристиках товара и сделают процесс оформления заказа быстрым и
            удобным.
          </p>
          <p>
            Обращайтесь по онлайн-чату, мессенджеру телеграм или звоните на
            номер +998993415115. Наши операторы работают с 9:00 до 18:00 каждый
            день. В остальное время вы можете оставить заявку в мессенджерах, и
            операторы рассмотрят ваше обращение в ближайшее время.
          </p>
        </Container>
      </section>
    </>
  );
}

export default Blog